/* Takes a two-letter state abbreviation, returns the complete name */
export const listStates = [
	{ desc: "Alabama", value: "AL" },
	{ desc: "Alaska", value: "AK" },
	{ desc: "Arizona", value: "AZ" },
	{ desc: "Arkansas", value: "AR" },
	{ desc: "California", value: "CA" },
	{ desc: "Northern California", value: "NCA" },
	{ desc: "Southern California", value: "SCA" },
	{ desc: "Colorado", value: "CO" },
	{ desc: "Connecticut", value: "CT" },
	{ desc: "Delaware", value: "DE" },
	{ desc: "Florida", value: "FL" },
	{ desc: "North Florida", value: "NFL" },
	{ desc: "South Florida", value: "SFL" },
	{ desc: "Georgia", value: "GA" },
	{ desc: "Hawaii", value: "HI" },
	{ desc: "Idaho", value: "ID" },
	{ desc: "Illinois", value: "IL" },
	{ desc: "Indiana", value: "IN" },
	{ desc: "Iowa", value: "IA" },
	{ desc: "Kansas", value: "KS" },
	{ desc: "Kentucky", value: "KY" },
	{ desc: "Louisiana", value: "LA" },
	{ desc: "Maine", value: "ME" },
	{ desc: "Maryland", value: "MD" },
	{ desc: "Massachusetts", value: "MA" },
	{ desc: "Michigan", value: "MI" },
	{ desc: "Minnesota", value: "MN" },
	{ desc: "Mississippi", value: "MS" },
	{ desc: "Missouri", value: "MO" },
	{ desc: "Montana", value: "MT" },
	{ desc: "Nebraska", value: "NE" },
	{ desc: "Nevada", value: "NV" },
	{ desc: "New Hampshire", value: "NH" },
	{ desc: "New Jersey", value: "NJ" },
	{ desc: "New Mexico", value: "NM" },
	{ desc: "New York", value: "NY" },
	{ desc: "North Carolina", value: "NC" },
	{ desc: "North Dakota", value: "ND" },
	{ desc: "Ohio", value: "OH" },
	{ desc: "Oklahoma", value: "OK" },
	{ desc: "Oregon", value: "OR" },
	{ desc: "Pennsylvania", value: "PA" },
	{ desc: "Rhode Island", value: "RI" },
	{ desc: "South Carolina", value: "SC" },
	{ desc: "South Dakota", value: "SD" },
	{ desc: "Tennessee", value: "TN" },
	{ desc: "Texas", value: "TX" },
	{ desc: "Utah", value: "UT" },
	{ desc: "Vermont", value: "VT" },
	{ desc: "Virginia", value: "VA" },
	{ desc: "Washington", value: "WA" },
	{ desc: "Washington DC", value: "DC" },
	{ desc: "West Virginia", value: "WV" },
	{ desc: "Wisconsin", value: "WI" },
	{ desc: "Wyoming", value: "WY" },
]

export const regions = {
			AL: "southeast",
			AK: "west",
			AZ: "southwest",
			AR: "southeast",
			CA: "west",
			SCA: "west",
			NCA: "west",
			CO: "west",
			CT: "northeast",
			DC: "northeast",
			DE: "northeast",
			FL: "southeast",
			SFL: "southeast",
			NFL: "southeast",
			GA: "southeast",
			HI: "west",
			ID: "west",
			IL: "midwest",
			IN: "midwest",
			IA: "midwest",
			KS: "midwest",
			KY: "southeast",
			LA: "southeast",
			ME: "northeast",
			MD: "northeast",
			MA: "northeast",
			MI: "midwest",
			MN: "midwest",
			MS: "southeast",
			MO: "midwest",
			MT: "west",
			NE: "midwest",
			NV: "west",
			NH: "northeast",
			NJ: "northeast",
			NM: "southwest",
			NY: "northeast",
			NC: "southeast",
			ND: "midwest",
			OH: "midwest",
			OK: "southwest",
			OR: "west",
			PA: "northeast",
			RI: "northeast",
			SC: "southeast",
			SD: "midwest",
			TN: "southeast",
			TX: "southwest",
			UT: "west",
			VT: "northeast",
			VA: "southeast",
			WA: "west",
			WV: "southeast",
			WI: "midwest",
			WY: "west",
		};
		
		
		
export const states = {
		AK: [61.385, -152.2683],
		AL: [32.799, -86.8073],
		AR: [34.9513, -92.3809],
		AS: [14.2417, -170.7197],
		AZ: [33.7712, -111.3877],
		// CA: [36.17, -119.7462],
		SCA: [33.9145, -117.9151],
		NCA: [37.5118, -121.5269],
		CO: [39.0646, -105.3272],
		CT: [41.5834, -72.7622],
		DC: [38.8964, -77.0262],
		DE: [39.3498, -75.5148],
		// FL: [27.8333, -81.717],
		SFL: [26.3580, -80.3996],
		NFL: [28.8317, -82.4225],
		GA: [32.9866, -83.6487],
		HI: [21.1098, -157.5311],
		IA: [42.0046, -93.214],
		ID: [44.2394, -114.5103],
		IL: [40.3363, -89.0022],
		IN: [39.8647, -86.2604],
		KS: [38.5111, -96.8005],
		KY: [37.669, -84.6514],
		LA: [31.1801, -91.8749],
		MA: [42.2373, -71.5314],
		MD: [39.0724, -76.7902],
		ME: [44.6074, -69.3977],
		MI: [43.3504, -84.5603],
		MN: [45.7326, -93.9196],
		MO: [38.4623, -92.302],
		MP: [14.8058, 145.5505],
		MS: [32.7673, -89.6812],
		MT: [46.9048, -110.3261],
		NC: [35.6411, -79.8431],
		ND: [47.5362, -99.793],
		NE: [41.1289, -98.2883],
		NH: [43.4108, -71.5653],
		NJ: [40.314, -74.5089],
		NM: [34.8375, -106.2371],
		NV: [38.4199, -117.1219],
		NY: [40.7128, -74.0059],
		OH: [40.3736, -82.7755],
		OK: [35.5376, -96.9247],
		OR: [44.5672, -122.1269],
		PA: [40.5773, -77.264],
		PR: [18.2766, -66.335],
		RI: [41.6772, -71.5101],
		SC: [33.8191, -80.9066],
		SD: [44.2853, -99.4632],
		TN: [35.7449, -86.7489],
		TX: [31.106, -97.6475],
		UT: [40.1135, -111.8535],
		VA: [37.768, -78.2057],
		VI: [18.0001, -64.8199],
		VT: [44.0407, -72.7093],
		WA: [47.3917, -121.5708],
		WI: [44.2563, -89.6385],
		WV: [38.468, -80.9696],
		WY: [42.7475, -107.2085],
		XE: [36.3859, -68.3047],
		XW: [37.4748, -130.3926],
		XS: [20.5505, -101.6084],
		XN: [59.1984, -111.8916],
	};

export const cities = [
		["AK", 61.1743, -149.2843],
		["AL", 33.5274, -86.799],
		["AL", 32.3472, -86.2661],
		["AL", 34.699, -86.673],
		["AL", 30.6684, -88.1002],
		["AR", 34.7254, -92.3586],
		["AZ", 33.5722, -112.0901],
		["AZ", 32.1531, -110.8706],
		["AZ", 33.4019, -111.7174],
		["AZ", 33.2829, -111.8549],
		["AZ", 33.6843, -111.8611],
		["AZ", 33.5331, -112.1899],
		["AZ", 33.3103, -111.7431],
		["AZ", 33.3884, -111.9318],
		["AZ", 33.7862, -112.308],
		["AZ", 33.6706, -112.4527],
		["NCA", 37.2967, -121.8189],
		["NCA", 37.7272, -123.0322],
		["NCA", 36.7836, -119.7934],
		["NCA", 38.5666, -121.4686],
		["NCA", 37.7698, -122.2257],
		["NCA", 37.9763, -121.3133],
		["NCA", 37.4945, -121.9412],
		["NCA", 37.6375, -121.003],
		["NCA", 38.4468, -122.7061],
		["NCA", 38.4146, -121.385],
		["NCA", 37.6287, -122.1024],
		["NCA", 36.6902, -121.6337],
		["NCA", 37.3858, -122.0263],
		["NCA", 38.769, -121.3189],
		["NCA", 36.3273, -119.3289],
		["NCA", 37.9722, -122.0016],
		["NCA", 37.3646, -121.9679],
		["NCA", 38.1079, -122.264],
		["NCA", 37.867, -122.2991],
		["NCA", 38.2593, -122.0321],
		["NCA", 37.9791, -121.7962],
		["NCA", 37.9523, -122.3606],
		["NCA", 36.8282, -119.6849],
		["NCA", 37.7009, -122.465],
		["NCA", 37.5603, -122.3106],
		["NCA", 40.8021, -124.1637],
		["NCA", 40.5179, -121.6778],
		["NCA", 34.448, -119.2429],
		["NCA", 34.4208, -119.6982],
		["NCA", 34.4187, -119.5743],
		["NCA", 35.7525, -120.6963],
		["SCA", 34.0194, -118.4108],
		["SCA", 32.8153, -117.135],
		["SCA", 33.8092, -118.1553],
		["SCA", 35.3212, -119.0183],
		["SCA", 33.8555, -117.7601],
		["SCA", 33.7363, -117.883],
		["SCA", 33.9381, -117.3932],
		["SCA", 32.6277, -117.0152],
		["SCA", 33.6784, -117.7713],
		["SCA", 34.1416, -117.2936],
		["SCA", 34.109, -117.4629],
		["SCA", 34.2023, -119.2046],
		["SCA", 33.9233, -117.2057],
		["SCA", 34.1814, -118.2458],
		["SCA", 33.6906, -118.0093],
		["SCA", 34.403, -118.5042],
		["SCA", 34.1233, -117.5642],
		["SCA", 33.2245, -117.3062],
		["SCA", 33.7788, -117.9605],
		["SCA", 34.0394, -117.6042],
		["SCA", 33.862, -117.5655],
		["SCA", 34.6936, -118.1753],
		["SCA", 34.591, -118.1054],
		["SCA", 34.0585, -117.7611],
		["SCA", 33.1331, -117.074],
		["SCA", 33.835, -118.3414],
		["SCA", 34.1606, -118.1396],
		["SCA", 33.8857, -117.928],
		["SCA", 33.787, -117.8613],
		["SCA", 34.1933, -118.8742],
		["SCA", 34.2669, -118.7485],
		["SCA", 34.5277, -117.3536],
		["SCA", 34.0746, -118.0291],
		["SCA", 33.1239, -117.2828],
		["SCA", 33.9382, -118.1309],
		["SCA", 33.4931, -117.1317],
		["SCA", 33.6659, -117.9123],
		["SCA", 33.5721, -117.1904],
		["SCA", 33.9561, -118.3443],
		["SCA", 34.2678, -119.2542],
		["SCA", 34.0559, -117.9099],
		["SCA", 34.9332, -120.4438],
		["SCA", 33.9076, -118.0835],
		["SCA", 34.1901, -118.3264],
		["SCA", 32.8017, -116.9604],
		["SCA", 34.0026, -117.4676],
		["SCA", 34.1118, -117.3883],
		["SCA", 33.1895, -117.2386],
		["CO", 39.7619, -104.8811],
		["CO", 38.8673, -104.7607],
		["CO", 39.688, -104.6897],
		["CO", 40.5482, -105.0648],
		["CO", 39.6989, -105.1176],
		["CO", 39.9194, -104.9428],
		["CO", 39.8337, -105.1503],
		["CO", 39.8822, -105.0644],
		["CO", 38.2699, -104.6123],
		["CO", 39.5906, -104.8691],
		["CO", 40.027, -105.2519],
		["CO", 40.4153, -104.7697],
		["CT", 41.1874, -73.1958],
		["CT", 41.3108, -72.925],
		["CT", 41.0799, -73.546],
		["CT", 41.7659, -72.6816],
		["CT", 41.5585, -73.0367],
		["DC", 38.9041, -77.0172],
		["NFL", 30.3369, -81.6616],
		["NFL", 27.9701, -82.4797],
		["NFL", 28.4166, -81.2736],
		["NFL", 27.762, -82.6441],
		["NFL", 30.4551, -84.2534],
		["NFL", 29.6788, -82.3461],
		["NFL", 27.9789, -82.7666],
		["NFL", 28.0555, -81.9549],
		["SFL", 25.7752, -80.2086],
		["SFL", 25.8699, -80.3029],
		["SFL", 27.2806, -80.3883],
		["SFL", 26.6432, -81.9974],
		["SFL", 26.1412, -80.1467],
		["SFL", 26.021, -80.3404],
		["SFL", 26.031, -80.1646],
		["SFL", 25.977, -80.3358],
		["SFL", 26.2707, -80.2593],
		["SFL", 25.9489, -80.2436],
		["SFL", 27.9856, -80.6626],
		["SFL", 26.2416, -80.1339],
		["SFL", 26.7464, -80.1251],
		["SFL", 26.0791, -80.285],
		["GA", 33.7629, -84.4227],
		["GA", 32.5102, -84.8749],
		["GA", 33.3655, -82.0734],
		["GA", 32.8088, -83.6942],
		["GA", 32.0025, -81.1536],
		["GA", 33.9496, -83.3701],
		["GA", 33.9315, -84.3687],
		["HI", 21.3243, -157.8476],
		["IA", 41.5726, -93.6102],
		["IA", 41.967, -91.6778],
		["IA", 41.5541, -90.604],
		["ID", 43.6002, -116.2317],
		["IL", 41.8376, -87.6818],
		["IL", 41.7635, -88.2901],
		["IL", 41.5177, -88.1488],
		["IL", 42.2588, -89.0646],
		["IL", 41.7492, -88.162],
		["IL", 39.7911, -89.6446],
		["IL", 40.7515, -89.6174],
		["IL", 42.0396, -88.3217],
		["IN", 39.7767, -86.1459],
		["IN", 41.0882, -85.1439],
		["IN", 37.9877, -87.5347],
		["IN", 41.6769, -86.269],
		["KS", 37.6907, -97.3459],
		["KS", 38.889, -94.6906],
		["KS", 39.1225, -94.7418],
		["KS", 38.8843, -94.8195],
		["KS", 39.0347, -95.6962],
		["KY", 38.1654, -85.6474],
		["KY", 38.0407, -84.4583],
		["LA", 30.0534, -89.9345],
		["LA", 30.4422, -91.1309],
		["LA", 32.4669, -93.7922],
		["LA", 30.2074, -92.0285],
		["MA", 42.332, -71.0202],
		["MA", 42.2695, -71.8078],
		["MA", 42.1155, -72.54],
		["MA", 42.376, -71.1187],
		["MA", 42.639, -71.3211],
		["MD", 39.3, -76.6105],
		["MI", 42.383, -83.1022],
		["MI", 42.9612, -85.6556],
		["MI", 42.4929, -83.025],
		["MI", 42.5812, -83.0303],
		["MI", 42.2761, -83.7309],
		["MI", 42.7143, -84.5593],
		["MI", 42.5903, -82.917],
		["MI", 42.5903, -82.917],
		["MN", 44.9633, -93.2683],
		["MN", 44.9489, -93.1041],
		["MN", 44.0154, -92.4772],
		["MO", 39.1251, -94.551],
		["MO", 38.6357, -90.2446],
		["MO", 37.1942, -93.2913],
		["MO", 38.9473, -92.3264],
		["MO", 39.0855, -94.3521],
		["MS", 32.3158, -90.2128],
		["MT", 45.7885, -108.5499],
		["NC", 35.2078, -80.831],
		["NC", 35.8306, -78.6418],
		["NC", 36.0951, -79.827],
		["NC", 35.9811, -78.9029],
		["NC", 36.1027, -80.261],
		["NC", 35.0828, -78.9735],
		["NC", 35.7809, -78.8133],
		["NC", 34.2092, -77.8858],
		["NC", 35.99, -79.9905],
		["ND", 46.8652, -96.829],
		["NE", 41.2644, -96.0451],
		["NE", 40.8105, -96.6803],
		["NH", 42.9849, -71.4441],
		["NJ", 40.7242, -74.1726],
		["NJ", 40.7114, -74.0648],
		["NJ", 40.9148, -74.1628],
		["NJ", 40.6664, -74.1935],
		["NJ", 40.504, -74.3494],
		["NY", 40.0771, -74.2004],
		["NM", 35.1056, -106.6474],
		["NM", 32.3264, -106.7897],
		["NV", 36.2292, -115.2601],
		["NV", 36.0097, -115.0357],
		["NV", 39.5491, -119.8499],
		["NV", 36.2857, -115.0939],
		["NY", 40.6635, -73.9387],
		["NY", 42.8925, -78.8597],
		["NY", 43.1699, -77.6169],
		["NY", 40.9459, -73.8674],
		["NY", 43.041, -76.1436],
		["OH", 39.9852, -82.9848],
		["OH", 41.4785, -81.6794],
		["OH", 39.1402, -84.5058],
		["OH", 41.6641, -83.5819],
		["OH", 41.0805, -81.5214],
		["OH", 39.7774, -84.1996],
		["OK", 35.4671, -97.5137],
		["OK", 36.1279, -95.9023],
		["OK", 35.2406, -97.3453],
		["OK", 36.0365, -95.781],
		["OR", 45.537, -122.65],
		["OR", 44.9237, -123.0232],
		["OR", 44.0567, -123.1162],
		["OR", 45.5023, -122.4416],
		["OR", 45.528, -122.9357],
		["PA", 40.0094, -75.1333],
		["PA", 40.4398, -79.9766],
		["PA", 40.5936, -75.4784],
		["RI", 41.8231, -71.4188],
		["SC", 32.8179, -79.959],
		["SC", 34.0291, -80.898],
		["SC", 32.9178, -80.065],
		["SD", 43.5383, -96.732],
		["TN", 36.1718, -86.785],
		["TN", 35.1028, -89.9774],
		["TN", 35.9707, -83.9493],
		["TN", 35.066, -85.2484],
		["TN", 36.5664, -87.3452],
		["TN", 35.8522, -86.416],
		["TX", 29.7866, -95.3909],
		["TX", 29.4724, -98.5251],
		["TX", 32.7933, -96.7665],
		["TX", 30.3039, -97.7544],
		["TX", 32.7815, -97.3467],
		["TX", 31.8484, -106.427],
		["TX", 32.7007, -97.1247],
		["TX", 27.7543, -97.1734],
		["TX", 33.0508, -96.7479],
		["TX", 27.5604, -99.4892],
		["TX", 33.5656, -101.8867],
		["TX", 32.8577, -96.97],
		["TX", 32.9098, -96.6303],
		["TX", 35.1999, -101.8302],
		["TX", 32.6869, -97.0211],
		["TX", 25.9991, -97.455],
		["TX", 33.1985, -96.668],
		["TX", 33.1554, -96.8226],
		["TX", 29.6586, -95.1506],
		["TX", 32.7629, -96.5888],
		["TX", 31.0777, -97.732],
		["TX", 26.2322, -98.2464],
		["TX", 32.0246, -102.1135],
		["TX", 31.5601, -97.186],
		["TX", 33.2166, -97.1414],
		["TX", 32.9884, -96.8998],
		["TX", 32.4545, -99.7381],
		["TX", 30.5252, -97.666],
		["TX", 30.0849, -94.1453],
		["TX", 31.8838, -102.3411],
		["TX", 29.5558, -95.3231],
		["TX", 32.9723, -96.7081],
		["TX", 30.5852, -96.2964],
		["TX", 32.3173, -95.3059],
		["TX", 33.9067, -98.5259],
		["TX", 33.0466, -96.9818],
		["TX", 29.4901, -95.1091],
		["TX", 31.4411, -100.4505],
		["TX", 31.4411, -100.4505],
		["UT", 40.7769, -111.931],
		["UT", 40.6885, -112.0118],
		["UT", 40.2453, -111.6448],
		["UT", 40.6024, -112.0008],
		["VA", 36.78, -76.0252],
		["VA", 36.923, -76.2446],
		["VA", 36.6794, -76.3018],
		["VA", 37.5314, -77.476],
		["VA", 37.0762, -76.522],
		["VA", 38.8201, -77.0841],
		["VA", 37.048, -76.2971],
		["WA", 47.6205, -122.3509],
		["WA", 47.6669, -117.4333],
		["WA", 47.2522, -122.4598],
		["WA", 45.6349, -122.5957],
		["WA", 47.5979, -122.1565],
		["WA", 47.388, -122.2127],
		["WA", 47.9566, -122.1914],
		["WA", 47.4761, -122.192],
		["WA", 47.4761, -122.192],
		["WI", 43.0633, -87.9667],
		["WI", 43.0878, -89.4299],
		["WI", 44.5207, -87.9842],
	];